import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { companyPreferencesStateSelector } from '~/selectors';

type GeneralBooleanFlag =
  | 'isLoadingAllCompanyPreferences'
  | 'failedToLoadAllCompanyPreferences'
  | 'isClearingAllCompanyPreferences'
  | 'failedToClearAllCompanyPreferences';

type IndividualBooleanFlag =
  | 'isLoading'
  | 'failedToLoad'
  | 'isClearing'
  | 'failedToClear';

/**
 * General boolean flag will prevail over individual
 * ones to prevent the issues when individual flags
 * are not actual because of a mix of loading/clearing
 * all settings and individual ones in parallel.
 */
export const useCompanyPreferencesBooleanFlagSelector = (
  booleanFlag: IndividualBooleanFlag,
  keys?: string[],
): boolean => {
  return useSelector((state: StoreState) => {
    const companyPreferencesStoreState = companyPreferencesStateSelector(state);

    const generalBooleanFlag =
      companyPreferencesStoreState[
        `${booleanFlag}AllCompanyPreferences` as GeneralBooleanFlag
      ];

    return (
      generalBooleanFlag ||
      (keys || []).some((key) => {
        return companyPreferencesStoreState.companyPreferences[key]?.[
          booleanFlag
        ];
      })
    );
  });
};
